import React, { Component } from 'react';

import TextInput from '../../../../components/ZUILib/TextInput';
import InputButton from '../../../../components/ZUILib/InputButton';
import RadioButton from '../../../../components/ZUILib/RadioButton';
import CalenderSample from '../../../../components/ZUILib/CalenderSample';
import CheckBox from '../../../../components/ZUILib/CheckBox';
import commonUtil from '../../../../utils/commonUtil';
import errorLables from '../../../../utils/errors/LP_GR_error.json';
// eslint-disable-next-line no-unused-vars
import { constCookieDomainName } from '../../../../utils/clientConstant';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.toggleRemeberMeMessage = this.toggleRemeberMeMessage.bind(this);
  }
  userRegistration = {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    maternalName: '',
    bdayDAY: '',
    bdayMONTH: '',
    bdayYEAR: '',
    gender: '',
    autoLoginCheckbox: '',
  }
  isValueAvailable = (str) => {
    if (str && str.trim()) {
      return true;
    }
    return false;
  }
  validate = () => {
    const emailValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.email.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.email.required') },
      { functionRef: commonUtil.validateEmail, funcData: [this.email.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.email.invalid') },
    ];

    const firstNameValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.firstName.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.firstName.required') },
      { functionRef: commonUtil.validateName, funcData: [this.firstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.firstName.invalid') },
    ];

    const lastNameValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.lastName.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.lastName.required') },
      { functionRef: commonUtil.validateName, funcData: [this.lastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.lastName.invalid') },
    ];

    const passwordValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.password.required') },
      { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.password.invalid') },
    ];
    const isEmailValid = commonUtil.validateTextInput(emailValidationRules, this.email, null);
    const isFirstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.firstName, null);
    const isLastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.lastName, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRules, this.password, null);

    let isMaternalNameValid = true;
    const isGenderValid = true;
    let isdateValid = true;

    let maternalNameValidationRules = '';
    if (this.maternalName.getValue()) {
      maternalNameValidationRules = [
        { functionRef: commonUtil.validateName, funcData: [this.maternalName.getValue(), 1, true], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.maternalName.invalid') },
      ];
      isMaternalNameValid = commonUtil.validateTextInput(maternalNameValidationRules, this.maternalName, null);
    }

    let dateValidationRules = '';
    let tempDate = [];
    if (this.birthDate.state.date) {
      dateValidationRules = {
        functionRef: this.isValueAvailable, funcData: [this.birthDate.state.date], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.date.required'),
      };
      isdateValid = commonUtil.validateCalendarInput(dateValidationRules, this.birthDate, null);
      if (isdateValid) {
        tempDate = this.date.split('/');
      }
    }
    if (isEmailValid && isPasswordValid && isFirstNameValid && isLastNameValid && isMaternalNameValid && isGenderValid && isdateValid) {
      this.userRegistration.email = this.email.getValue();
      this.userRegistration.password = this.password.getValue();
      this.userRegistration.firstName = this.firstName.getValue();
      this.userRegistration.lastName = this.lastName.getValue();
      this.userRegistration.maternalName = this.maternalName.getValue();
      this.userRegistration.bdayDAY = tempDate[0];
      this.userRegistration.bdayMONTH = tempDate[1];
      this.userRegistration.bdayYEAR = tempDate[2];
      this.userRegistration.gender = this.gender;
      this.userRegistration.autoLoginCheckbox = this.userAutoLogingChk.isChecked() ? 'true' : 'false';
    }
    const { email, password, firstName, lastName } = this.userRegistration;
    if (email && password && firstName && lastName) {
      return true;
    }
    this.gtmTrackErrors(isEmailValid, isPasswordValid, isFirstNameValid, isLastNameValid, isMaternalNameValid, isGenderValid, isdateValid);
    return false;
  }
  gtmTrackErrors = (email, pwd, fName, lName, mName, gender, date) => {
    const errors = [];
    let individualError = {};

    if (!email) {
      individualError = {
        AccFormField: 'Email',
        AccFormErr: 'Error con el correo ingresado',
      };

      errors.push(individualError);
    }
    if (!pwd) {
      individualError = {
        AccFormField: 'Password',
        AccFormErr: 'Error con la contraseña ingresada',
      };

      errors.push(individualError);
    }
    if (!fName) {
      individualError = {
        AccFormField: 'First name',
        AccFormErr: 'Error con el nombre ingresado',
      };

      errors.push(individualError);
    }
    if (!lName) {
      individualError = {
        AccFormField: 'Last name',
        AccFormErr: 'Error con el apellido paterno ingresado',
      };

      errors.push(individualError);
    }
    if (!mName) {
      individualError = {
        AccFormField: 'Maternal name',
        AccFormErr: 'Error con el apellido materno ingresado',
      };

      errors.push(individualError);
    }
    if (!gender) {
      individualError = {
        AccFormField: 'Gender',
        AccFormErr: 'Error con el género ingresado',
      };

      errors.push(individualError);
    }
    if (!date) {
      individualError = {
        AccFormField: 'Date',
        AccFormErr: 'Error con la fecha ingresada',
      };

      errors.push(individualError);
    }
    errors.forEach((item) => {
        // eslint-disable-next-line no-undef
      dataLayer.push({
        event: 'AccFormErr',
        AccFormField: item.AccFormField,
        AccFormErr: item.AccFormErr,
      });
    });
  }
  handleSelectedGender = (selectedGender) => {
    if (selectedGender) {
      this.gender = selectedGender.value;
    }
  }
  handleCreateAccount = () => {
    if (this.validate()) {
      this.props._handleUserRegistration(this.userRegistration)
        .then((done) => {
          if (typeof done.status !== 'undefined' && done.status.status === 'success') {
            // eslint-disable-next-line no-undef
            dataLayer.push({
              event: 'AccForm',
            });
          }
        });
    }
  }
  openTermAndCondition = () => {
    window.open('https://assetspwa.liverpool.com.mx/ayuda/index.html#/sec/terminos-y-condiciones/proteccion-de-datos/aviso-clientes');
  }
  toggleRemeberMeMessage = () => {
    const autologinTooltip = document.querySelector('#' + this.autoLoginTooltipsignUpWeb.id);
    if (autologinTooltip.style.display === 'none') {
      autologinTooltip.style.display = 'block';
    } else {
      autologinTooltip.style.display = 'none';
    }
  }
  render() {
    const { lables } = this.props;
    // json for Radio Button
    const _genders = {
      htmlId: 'gender',
      title: commonUtil.getLabel(lables.createLogin, 'create.account.sexo.label'),
      displayName: commonUtil.getLabel(lables.createLogin, 'create.account.sexo.label'),
      name: 'gender',
      defaultValue: 'hombre',
      options: [
        {
          id: 'genderMale',
          value: 'male',
          title: commonUtil.getLabel(lables.createLogin, 'create.account.gender.male'),
          displayName: commonUtil.getLabel(lables.createLogin, 'create.account.gender.male'),
          labelResourceId: commonUtil.getLabel(lables.createLogin, 'create.account.gender.male'),
          selected: true,
        },
        {
          id: 'genderFemale',
          value: 'female',
          title: commonUtil.getLabel(lables.createLogin, 'create.account.gender.female'),
          displayName: commonUtil.getLabel(lables.createLogin, 'create.account.gender.female'),
          labelResourceId: commonUtil.getLabel(lables.createLogin, 'create.account.gender.female'),
        },
      ],
    };
    const textInputAttr = {
      textClassName: 'form-control',
      textPlaceholder: commonUtil.getLabel(lables.createLogin, 'create.account.dob.label'),
    };
    const rememberMeCheckBoxConfig = {
      displayName: commonUtil.getLabel(lables.createLogin, 'login.keep.me.login'),
      id: 'signupchk',
      name: '',
      value: '',
      disabled: '',
    };

    // json for button Create Account
    const createAccountButton = {
      type: 'button',
      value: 'Aceptar',
      autoFocus: false,
      style: 'btnPrimaryAction size-Large',
      onClickHandler: this.handleCreateAccount,
    };
    const currentDate = new Date();
    const startDate = new Date('january 01, 1900');
    return (
      <div className="col-xs-12 col-sm-6 col-md-4 col-md-offset-1" id="sectionAccount">
        <h5 className="fontBold">{commonUtil.getLabel(lables.createLogin, 'create.user')}</h5>
        <form id="createNewAccount">
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="correo"
              label={commonUtil.getLabel(lables.createLogin, 'create.account.email')}
              name="Correo"
              maxlength="100"
              required="true"
              star="*"
              ref={email => this.email = email}
            />
          </div>
          <div className="formBlock">
            <TextInput
              type="password"
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="createAccountContraseña"
              label={commonUtil.getLabel(lables.createLogin, 'create.account.password')}
              name="Contraseña"
              required="true"
              star="*"
              ref={password => this.password = password}
            />
          </div>
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="nombre"
              label={commonUtil.getLabel(lables.createLogin, 'create.account.name')}
              maxlength="100"
              name="Nombre"
              required="true"
              star="*"
              ref={firstName => this.firstName = firstName}
            />
          </div>
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="apellidoPaterno"
              label={commonUtil.getLabel(lables.createLogin, 'create.account.paternal.name')}
              maxlength="100"
              name="Apellido Paterno"
              required="true"
              star="*"
              ref={lastName => this.lastName = lastName}
            />
          </div>
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="apellidomaterno"
              maxlength="100"
              label={commonUtil.getLabel(lables.createLogin, 'create.account.maternal.name')}
              name="Apellido Materno"
              required="true"
              ref={maternalName => this.maternalName = maternalName}
            />
          </div>
          <div className="genderWrap">
            <div className="col-sm-4 col-md-4 fontBold" name="gender">Sexo</div>
            {_genders.options.map((option, index) => (
              <div className="col-sm-4 col-md-4" key={'signUp' + index}>
                <RadioButton displayName={option.displayName} id={option.id} value={option.value} title={option.title} radioCssClass={'radio'} name={_genders.name} onChangeFunction={this.handleSelectedGender} />
              </div>
            ))}
            <div className="error" />
          </div>
          <div className="inputBlock">
            <div className="input-group date" id="datetimepicker1">
              <CalenderSample
                textInputJSON={textInputAttr}
                ref={birthDate => this.birthDate = birthDate}
                activeStartDate={currentDate}
                minDate={startDate}
                maxDate={currentDate}
                viewType="decade"
                onChangeHandler={date => this.date = date}
              />
            </div>
          </div>
          {/* eslint-disable */}
          <div className="row">
            <div className="col-xs-12 p-l-20">
              <CheckBox displayName={rememberMeCheckBoxConfig.displayName} id={rememberMeCheckBoxConfig.id} ref={(e) => { this.userAutoLogingChk = e; }}>
                <a class="p-l-15" onClick={this.toggleRemeberMeMessage}>{commonUtil.getLabel(lables.createLogin, 'login.detalla.link')}<i className="icon-caret_down" /></a>
                <div className="homeSessionContainerCreateAccount" style={{ 'display': 'none' }} id="signUpWebToolTip" ref={(e) => { this.autoLoginTooltipsignUpWeb = e; }}>
                  <div className="rememberMeContent">
                    <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.header.content')} <i className="icon-tache closeContainer" onClick={this.toggleRemeberMeMessage} /></p>
                    <hr />
                    <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content1')}</p>
                    <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content2')}</p>
                  </div>
                </div>
              </CheckBox>
            </div>
          </div>
          <p className="termCondition">{commonUtil.getLabel(lables.createLogin, 'create.account.terms.cndition.msg')}
            <a className="linkTermCondition" onClick={this.openTermAndCondition} > {commonUtil.getLabel(lables.createLogin, 'create.account.terms.cndition.label')}</a>
          </p>
          <div className="col-sm-12 col-md-12 textToRight">
            <InputButton buttonAttr={createAccountButton} />
          </div>
        </form>
      </div>
    );
  }
}

export default SignUp;
